
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const PluginDocumentation = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Documentation</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <Link to="#" className="block p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors text-center">
            Installation Guide
          </Link>
          <Link to="#" className="block p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors text-center">
            Plugin Configuration
          </Link>
          <Link to="#" className="block p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors text-center">
            Troubleshooting
          </Link>
          <Link to="#" className="block p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors text-center">
            API Reference
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};
